import React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  text: string;
  color?: 'blue' | 'purple' | 'teal' | 'yellow' | 'primary' | 'secondary' | 'default';
}

const Badge: React.FC<BadgeProps> = ({ text, color = 'default', className }) => {
  if (color === 'yellow')
    return (
      <span className="rounded-sm border border-yellow-200 bg-yellow-100 px-3 py-1 text-sm font-semibold text-yellow-600">
        {text}
      </span>
    );
  if (color === 'blue')
    return (
      <span className="rounded-sm border border-blue-200 bg-blue-100 px-3 py-1 text-sm font-semibold text-blue-600">
        {text}
      </span>
    );

  if (color === 'purple')
    return (
      <span className="rounded-sm border border-purple-200 bg-purple-100 px-3 py-1 text-sm font-semibold text-purple-600">
        {text}
      </span>
    );

  if (color === 'teal')
    return (
      <span className="rounded-sm border border-teal-200 bg-teal-100 px-3 py-1 text-sm font-semibold text-teal-600">
        {text}
      </span>
    );

  if (color === 'primary')
    return (
      <span className="border-primary-200 text-primary bg-secondary rounded-sm border px-3 py-1 text-sm font-semibold">
        {text}
      </span>
    );

  if (color === 'secondary')
    return (
      <span className="border-secondary-200 text-primary-600 bg-secondary-100 rounded-sm border px-3 py-1 text-sm font-semibold">
        {text}
      </span>
    );

  return (
    <span className={'rounded-sm border border-gray-200 bg-gray-100 px-3 py-1 text-gray-600' + className}>{text}</span>
  );
};

export default Badge;
